// Global auth token getter - will be set by the app
let globalGetAccessToken: (() => string | null) | null = null;

export const setGlobalAuthTokenGetter = (tokenGetter: () => string | null) => {
  globalGetAccessToken = tokenGetter;
};

export const getGlobalAccessToken = (): string | null => {
  if (globalGetAccessToken) {
    return globalGetAccessToken();
  }
  return null;
};

// Debug function to check localStorage for auth tokens
export const debugAuthTokens = (): void => {
  /* Debug logging disabled */
};
